import gql from "graphql-tag";

export default gql`
  query bookingEngineBestRateForRoomTypeAndStay($hotelId: String!, $startDate: DateTime!, $endDate: DateTime!, $roomTypeId: String!) {
     bestRate: bookingEngineBestRateForStay(hotelId: $hotelId, startDate: $startDate, endDate: $endDate, roomTypeId: $roomTypeId)
  }

`